import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=a35f04de&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageColumnTitle: require('/usr/src/motec/components/page/column/Title.vue').default,PageColumnTextBlock: require('/usr/src/motec/components/page/column/TextBlock.vue').default,PageColumnLinkToAnchor: require('/usr/src/motec/components/page/column/LinkToAnchor.vue').default,PageColumnImage: require('/usr/src/motec/components/page/column/Image.vue').default,PageColumnNumberedList: require('/usr/src/motec/components/page/column/NumberedList.vue').default,PageColumnHorizontalRule: require('/usr/src/motec/components/page/column/HorizontalRule.vue').default,PageColumnSocialMediaLinks: require('/usr/src/motec/components/page/column/SocialMediaLinks.vue').default,PageColumnMultiLinkToAnchor: require('/usr/src/motec/components/page/column/MultiLinkToAnchor.vue').default})
